export default ({ value }) => value.trim().split(" ").map(parseFloat);
